import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = {
  key: 0,
  class: "my-4 banner banner-light"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "ml-px text-yellow-900 material-icons-outlined" }, " error_outline ", -1)
const _hoisted_5 = { class: "" }
const _hoisted_6 = {
  key: 1,
  class: "my-4 banner banner-success"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "ml-px text-success material-icons-outlined" }, " check_circle_outline ", -1)
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "font-semibold" }
const _hoisted_11 = { class: "mt-2 list-disc list-inside" }
const _hoisted_12 = { class: "flex flex-col mt-2 md:mt-10 space-y-2 md:items-center md:flex-row md:space-y-0 md:space-x-4" }
const _hoisted_13 = {
  key: 0,
  class: "text-lg"
}
const _hoisted_14 = {
  key: 1,
  class: "text-lg"
}
const _hoisted_15 = { key: 2 }
const _hoisted_16 = {
  key: 3,
  class: "flex md:space-x-12 md:flex-row flex-col md:space-y-0 space-y-4"
}
const _hoisted_17 = {
  key: 1,
  class: "mt-10 text-muted"
}
const _hoisted_18 = {
  key: 2,
  class: "flex flex-col items-stretch mt-2 space-y-2"
}
const _hoisted_19 = { class: "text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Btn = _resolveComponent("Btn")!
  const _component_IntegrationSwitch = _resolveComponent("IntegrationSwitch")!
  const _component_PublishedOnClassroom = _resolveComponent("PublishedOnClassroom")!
  const _component_Timestamp = _resolveComponent("Timestamp")!
  const _component_CopyToClipboard = _resolveComponent("CopyToClipboard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.$t("event_editor.state_editor_title")), 1),
    (_ctx.isDraft)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.currentEventStateDescription), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.isPlanned)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.currentEventStateDescription), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      (_ctx.relevantErrors.length > 0)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass([{ shake: _ctx.shakeErrorBanner }, "mb-12 banner banner-danger"]),
            onAnimationend: _cache[0] || (_cache[0] = ($event: any) => (_ctx.shakeErrorBanner = false))
          }, [
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("event_editor.correct_errors_to_publish")), 1),
              _createElementVNode("ul", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relevantErrors, (error, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "text-muted text-danger-dark",
                    key: 'err-' + index
                  }, _toDisplayString(_ctx.$t("validation_errors.event." + error.$uid)), 1))
                }), 128))
              ])
            ])
          ], 34))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_12, [
        (_ctx.isDraft)
          ? (_openBlock(), _createElementBlock("h5", _hoisted_13, _toDisplayString(_ctx.$t("event_editor.current_state_is_draft")) + ". ", 1))
          : (_ctx.isPlanned)
            ? (_openBlock(), _createElementBlock("h5", _hoisted_14, _toDisplayString(_ctx.$t("event_editor.current_state_is_planned")) + ". ", 1))
            : (_openBlock(), _createElementBlock("h5", _hoisted_15, [
                _createTextVNode(_toDisplayString(_ctx.$t("event_editor.state_is")) + " ", 1),
                _createElementVNode("strong", null, _toDisplayString(_ctx.currentEventStateName), 1),
                _createTextVNode(". ")
              ])),
        (_ctx.isDraft || _ctx.isPlanned)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createVNode(_component_Btn, {
                class: "",
                variant: 'primary',
                loading: _ctx.loading,
                disabled: false && _ctx.isDraft && _ctx.v$.$invalid && _ctx.v$.$dirty,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (
							_ctx.isDraft
								? _ctx.v$.$invalid
									? _ctx.onInvalidSubmission()
									: _ctx.publish()
								: _ctx.revertToDraft()
						))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.isDraft ? _ctx.$t("event_editor.publish") : _ctx.$t("event_editor.revert_to_draft")), 1)
                ]),
                _: 1
              }, 8, ["loading", "disabled"]),
              (_ctx.isDraft && _ctx.showClassroomIntegrationSwitch && !_ctx.hasGoogleClassroomTwin)
                ? (_openBlock(), _createBlock(_component_IntegrationSwitch, {
                    key: 0,
                    class: "md:ml-auto bg-light pl-3 pr-2 rounded md:py-0 py-2",
                    modelValue: _ctx.publishToClassroom,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.publishToClassroom) = $event))
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.hasGoogleClassroomTwin)
          ? (_openBlock(), _createBlock(_component_PublishedOnClassroom, {
              key: 4,
              "remote-object-url": 
						_ctx.googleClassroomCourseWorkTwin.data.alternateLink ||
						(_ctx.googleClassroomCourseTwin
							? _ctx.googleClassroomCourseTwin.data.alternateLink
							: '')
					,
              class: "banner-success pl-3 pr-2 rounded md:py-0"
            }, null, 8, ["remote-object-url"]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.isPlanned)
        ? (_openBlock(), _createElementBlock("p", _hoisted_17, [
            _createTextVNode(_toDisplayString(_ctx.$t("event_editor.event_planned_help_text")) + " ", 1),
            _createElementVNode("strong", null, [
              _createVNode(_component_Timestamp, {
                value: _ctx.modelValue.begin_timestamp
              }, null, 8, ["value"])
            ]),
            _createTextVNode(". ")
          ]))
        : _createCommentVNode("", true),
      (_ctx.isPlanned || _ctx.isOpen)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$t("event_editor.this_is_the_link_to_the_event")), 1),
            _createVNode(_component_CopyToClipboard, { value: _ctx.permalink }, null, 8, ["value"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}